export const GATEKEEPER_STATES = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    NOT_INITIALIZED: 'NOT_INITIALIZED',
};
